import { render, staticRenderFns } from "./FormatView.vue?vue&type=template&id=128b30dc&scoped=true"
import script from "./FormatView.vue?vue&type=script&lang=js"
export * from "./FormatView.vue?vue&type=script&lang=js"
import style0 from "./FormatView.vue?vue&type=style&index=0&id=128b30dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b30dc",
  null
  
)

export default component.exports